class SidebarCollectionsMbl extends HTMLElement {
  connectedCallback() {
    this.initializeSlider();
  }

  disconnectCallback() {
    // Clean up event listeners and references
    if (this.buttonPrev) {
      this.buttonPrev.removeEventListener('click', this.handlePrevClick);
    }
    if (this.buttonNext) {
      this.buttonNext.removeEventListener('click', this.handleNextClick);
    }
    if (this.collectionLinks) {
      this.collectionLinks.forEach((link) => {
        link.removeEventListener('click', this.handleCollectionClick);
      });
    }
  }

  initializeSlider() {
    this.sliderWrapper = this.querySelector('.slider-wrapper');
    this.buttonPrev = this.querySelector('.prev');
    this.buttonNext = this.querySelector('.next');

    if (!this.sliderWrapper || !this.buttonPrev || !this.buttonNext) {
      return;
    }

    this.handleScroll = (direction) => {
      const item = this.sliderWrapper.querySelector('li');
      const itemWidth = item ? item.offsetWidth : this.sliderWrapper.offsetWidth;
      const scrollAmount = direction === 'prev' ? -itemWidth : itemWidth;

      this.sliderWrapper.scrollBy({
        top: 0,
        left: scrollAmount,
        behavior: 'smooth',
      });

      // Disable buttons temporarily
      this.buttonPrev.disabled = true;
      this.buttonNext.disabled = true;

      setTimeout(() => {
        // Correct position
        if (this.sliderWrapper.scrollLeft < 0) {
          this.sliderWrapper.scrollLeft = 0;
        }
        if (this.sliderWrapper.scrollLeft + this.sliderWrapper.clientWidth > this.sliderWrapper.scrollWidth) {
          this.sliderWrapper.scrollLeft = this.sliderWrapper.scrollWidth - this.sliderWrapper.clientWidth;
        }
        // Re-enable buttons
        this.buttonPrev.disabled = false;
        this.buttonNext.disabled = false;
        // Adjust timeout as needed (500ms for smooth behavior)
      }, 500);
    };

    this.handlePrevClick = () => this.handleScroll('prev');
    this.handleNextClick = () => this.handleScroll('next');

    // Method to scroll to the active item
    this.scrollToActiveSlide = () => {
      const activeItem = this.sliderWrapper.querySelector('li.active');
      if (activeItem) {
        const itemRect = activeItem.getBoundingClientRect();
        const wrapperRect = this.sliderWrapper.getBoundingClientRect();
        // Calculate scroll position to show the active item at the start of the visible area
        const scrollLeft = this.sliderWrapper.scrollLeft + itemRect.left - wrapperRect.left;
        this.sliderWrapper.scrollTo({
          left: scrollLeft,
          behavior: 'smooth',
        });
      }
    };

    // Save selected collection to localStorage
    this.saveSelectedCollection = (collectionUrl) => {
      try {
        localStorage.setItem('selectedCollection', collectionUrl);
      } catch (error) {
        // Silently handle localStorage errors
      }
    };

    this.handleCollectionClick = (event) => {
      this.saveSelectedCollection(event.target.getAttribute('href'));
    };

    // Add click listeners to collection links
    this.collectionLinks = this.sliderWrapper.querySelectorAll('a');
    this.collectionLinks.forEach((link) => {
      link.addEventListener('click', this.handleCollectionClick);
    });

    this.buttonPrev.addEventListener('click', this.handlePrevClick);
    this.buttonNext.addEventListener('click', this.handleNextClick);

    // Scroll to active slide after a short delay to ensure DOM is ready
    setTimeout(() => {
      this.scrollToActiveSlide();
    }, 10);
  }
}

if (!customElements.get('sidebar-collections-mbl')) {
  customElements.define('sidebar-collections-mbl', SidebarCollectionsMbl);
}
